import React from "react";
import { useSelector } from "react-redux";
// import { useStyles } from "./styles";
import EarningDeviceView from "../../../views/myEarningsView/components/EarningDeviceView";
import PropTypes from "prop-types";
function EarningsDevice(props) {
  const { earningsModel, moduleName, timestamp, ...other } = props;
  const getColor = {
    Activation: {
      color: "#E2B422",
    },
    Recharge: {
      color: "#9CF26E",
    },
    Device: {
      color: "#7caeea",
    },
  };
  if (earningsModel.isSectionActive === "Y") {
    if (
      earningsModel.secTilesMasterTxDtos &&
      earningsModel.secTilesMasterTxDtos.length
    ) {
      return (
        <EarningDeviceView
          earningsModel={earningsModel}
          moduleName={moduleName}
          timestamp={timestamp}
          getColor={getColor}
          sectionName={moduleName}
          data={props.data}
        />
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}
EarningsDevice.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any,
    })
  ),
};

export default EarningsDevice;
